import { makeApiRequest } from 'actions/api';
export const GET_HOME_PROFILE = 'GET_HOME_PROFILE';
export const GET_HOME_PROFILE_REQUEST = 'GET_HOME_PROFILE_REQUEST';
export const GET_HOME_PROFILE_RESPONSE = 'GET_HOME_PROFILE_RESPONSE';
export const GET_HOME_PROFILE_ERROR = 'GET_HOME_PROFILE_ERROR';
import { ensureFavoritesData } from 'actions/dashboard';
import { getCreditDetails, getOfferRewards, getVoucherDetails } from 'actions/offerRewards';
import { getHomepagePreviousBaskets } from 'actions/previousBaskets';
import { getPromotions } from 'actions/promotions';
import { getStreakOffers } from 'actions/streakOffers';
import { getSuggestedPairings } from 'actions/suggestedPairings';
import { getUser } from 'actions/user';
import { getBasketSummary as getBasketSummaryV3 } from 'actions/v3/baskets';
import { getHomeReviewableMeals } from 'actions/v3/reviewableMeals';
import { getUserBehavioralDiscounts } from 'actions/v3/userBehavioralDiscounts';
import * as fromAccount from 'reducers/account';
import * as fromDashboard from 'selectors/dashboard';
import * as ErrorLogging from 'services/ErrorLogging';
import RequestService from 'services/RequestService';

import { getViewableBaskets } from './v3/baskets';

const getProfile = () =>
  makeApiRequest({
    requestType: GET_HOME_PROFILE,
    method: RequestService.getHomeProfile,
  });

export const bootstrapHomepage = () => async dispatch => {
  await dispatch(getViewableBaskets());

  const profileResponse = await dispatch(getProfile());

  profileResponse.ok
    ? dispatch(fetchBasketSummary(profileResponse.currentMenu.slug))
    : ErrorLogging.captureInfo(profileResponse.error);

  dispatch(getCreditDetails());
  dispatch(getHomepagePreviousBaskets());
  dispatch(getPromotions());
  dispatch(getOfferRewards());
  dispatch(getUser());
  dispatch(getVoucherDetails());
  dispatch(getHomeReviewableMeals());
  dispatch(ensureFavoritesData());
};

export const fetchBasketSummary = menuSlug => {
  return (dispatch, getState) => {
    const state = getState();
    const hasSuggestedPairings =
      fromDashboard.selectSuggestedPairingsForMenu(state, menuSlug).length > 0;
    const hasBehavioralDiscounts =
      fromDashboard.selectUserBehavioralDiscountsForMenu(state, menuSlug).length > 0;
    const hasStreakOffers = fromAccount.selectStreakOffers(state).length > 0;
    const promises = [
      dispatch(getBasketSummaryV3(menuSlug)),
      !hasSuggestedPairings && dispatch(getSuggestedPairings(menuSlug)),
      !hasBehavioralDiscounts && dispatch(getUserBehavioralDiscounts(menuSlug)),
      !hasStreakOffers && dispatch(getStreakOffers()),
    ].filter(Boolean);
    return Promise.all(promises);
  };
};
